class FacetFiltersForm extends HTMLElement {
    constructor() {
      super();
      this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
  
      this.debouncedOnSubmit = debounce((event) => {
        this.onSubmitHandler(event);
      }, 500);
  
      const facetForm = this.querySelector('form');
      facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
  
      const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
      if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

      // Ajouter l'écouteur de changement sur le sélecteur mobile
      const selectMobile = document.getElementById('SortBy-mobile-2');
      const selectHidden = document.getElementById('SortBy-mobile');
      if (selectMobile && selectHidden) {
        selectMobile.addEventListener('change', () => {
          // Mettre à jour le sélecteur caché avec la même valeur
          selectHidden.value = selectMobile.value;

          // Créer les nouveaux paramètres de recherche
          const searchParams = new URLSearchParams(window.location.search);
          searchParams.set('sort_by', selectMobile.value);

          // Appeler FacetFiltersForm.renderPage() pour actualiser la page
          FacetFiltersForm.renderPage(searchParams.toString(), null, true);
        });
      }

    }
    
    static setListeners() {
      const onHistoryChange = (event) => {
        const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
        if (searchParams === FacetFiltersForm.searchParamsPrev) return;
        FacetFiltersForm.renderPage(searchParams, null, false);
      }
      window.addEventListener('popstate', onHistoryChange);
    }
  
    static toggleActiveFacets(disable = true) {
      document.querySelectorAll('.js-facet-remove').forEach((element) => {
        element.classList.toggle('disabled', disable);
      });
    }
  
    static renderPage(searchParams, event, updateURLHash = true) {
      FacetFiltersForm.searchParamsPrev = searchParams;
      const sections = FacetFiltersForm.getSections();
      const countContainer = document.getElementById('ProductCount');
      const countContainerDesktop = document.getElementById('ProductCountDesktop');
      document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
      if (countContainer){
        countContainer.classList.add('loading');
      }
      if (countContainerDesktop){
        countContainerDesktop.classList.add('loading');
      }
  
      sections.forEach((section) => {
        const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
        const filterDataUrl = element => element.url === url;
  
        FacetFiltersForm.filterData.some(filterDataUrl) ?
          FacetFiltersForm.renderSectionFromCache(filterDataUrl, event, searchParams) :
          FacetFiltersForm.renderSectionFromFetch(url, event, searchParams);
      });
  
      if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
    }
  
    static renderSectionFromFetch(url, event, searchParams) {
      fetch(url)
        .then(response => response.text())
        .then((responseText) => {
          const html = responseText;
          FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
          FacetFiltersForm.renderFilters(html, event);
          FacetFiltersForm.renderProductGridContainer(html, searchParams);
          FacetFiltersForm.renderProductCount(html);
          // Déclenchement de l'événement personnalisé
          const eventCustom = new Event('productGridUpdated');
          document.dispatchEvent(eventCustom);
        });
    }
  
    static renderSectionFromCache(filterDataUrl, event, searchParams) {
      const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
      FacetFiltersForm.renderFilters(html, event);
      FacetFiltersForm.renderProductGridContainer(html, searchParams);
      FacetFiltersForm.renderProductCount(html);
      // Déclenchement de l'événement personnalisé
      const eventCustom = new Event('productGridUpdated');
      document.dispatchEvent(eventCustom);
    }
  
    static renderProductGridContainer(html, searchParams) {

      const variantContainer = document.getElementById('ProductGridContainer');
      const variantGrid = variantContainer.querySelector('#product-grid');
      variantGrid.innerHTML = '';
      const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
      const variantItems = parsedHTML.querySelectorAll('.grid__item');
      
      variantItems.forEach((item) => {
        const variantMatchesFilter = FacetFiltersForm.variantMatchesFilter(item);
        if (variantMatchesFilter) {
            variantGrid.appendChild(item);
           updateLinks()
        } else {
          console.log('Variant not found')
        }
      });

      const wrapper = document.querySelector('.prefilters-wrapper');
      if (searchParams && searchParams.length > 0) wrapper.scrollIntoView({ behavior: "instant", block: "start" });
    
      variantContainer.querySelector('.collection').classList.remove('loading');
    }
    
    static variantMatchesFilter(variantElement) {
      const selectedColors = Array.from(document.querySelectorAll('[name="filter.v.option.couleur"]:checked'))
                                  .map(input => input.value.toLowerCase());
      const selectedSizes = Array.from(document.querySelectorAll('[name="filter.v.option.taille"]:checked'))
                                 .map(input => input.value.toLowerCase());
    
      const variantColor = variantElement.getAttribute('data-color');
      const variantSize = variantElement.getAttribute('data-size');
    
      const matchesColor = selectedColors.length === 0 || selectedColors.includes(variantColor);
      const matchesSize = selectedSizes.length === 0 || selectedSizes.includes(variantSize);
    
      return matchesColor && matchesSize;
    }
  
    static renderProductCount(html) {
      const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
      const container = document.getElementById('ProductCount');
      const containerDesktop = document.getElementById('ProductCountDesktop');
      container.innerHTML = count;
      container.classList.remove('loading');
      if (containerDesktop) {
        containerDesktop.innerHTML = count;
        containerDesktop.classList.remove('loading');
      }
    }
  
    static renderFilters(html, event) {
      const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

        // Sélectionne les éléments de variantes à partir du HTML analysé
        const variantItems = parsedHTML.querySelectorAll('.grid__item');

        // Récupère les filtres du HTML
        const filters = FacetFiltersForm.getFiltersFromHTML(parsedHTML);

        // Compte et met à jour les variantes disponibles pour chaque filtre
        FacetFiltersForm.countVariantsForFilters(variantItems, filters);
  
      const facetDetailsElements =
        parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
      const matchesIndex = (element) => {
        const jsFilter = event ? event.target.closest('.js-filter') : undefined;
        return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
      }
      const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
      const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);
  
      facetsToRender.forEach((element) => {
        document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
      });
  
      FacetFiltersForm.renderActiveFacets(parsedHTML);
      FacetFiltersForm.renderAdditionalElements(parsedHTML);
  
      if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
    }

    static countVariantsForFilters(variantItems, filters) {
        // Compte le nombre de variantes disponibles pour chaque valeur de filtre
        filters.forEach(filter => {
          filter.values.forEach(value => {
            let variantCount = 0;
    
            variantItems.forEach(variantItem => {
              const variantOptions = [
                variantItem.getAttribute('data-size'),
                variantItem.getAttribute('data-color'),
              ];
              const variantAvailable = variantItem.getAttribute('data-available') === 'true';
              const matchesVariantOptions = variantOptions.includes(value.label);
    
              // Vérifie les métadonnées personnalisées si disponibles
              const matchesMetafields = FacetFiltersForm.checkMetafieldsMatch(variantItem, value.label);
    
              // Si une variante correspond aux critères de filtre, on l'inclut dans le comptage
              if (matchesVariantOptions || matchesMetafields) {
                variantCount++;
              }
            });
    
            // Met à jour l'affichage du nombre de variantes pour chaque valeur de filtre
            const filterElement = document.querySelector(`#Filter-${filter.param_name}-${value.index}`);
            if (filterElement) {
              const countSpan = filterElement.parentElement.querySelector('span[aria-hidden="true"]');
              if (countSpan) {
                countSpan.textContent = `${value.label} (${variantCount})`;
              }
    
              // Met à jour l'attribut disabled si aucune variante disponible
              if (variantCount === 0) {
                filterElement.setAttribute('disabled', 'disabled');
              } else {
                filterElement.removeAttribute('disabled');
              }
            }
          });
        });
      }
    
      static checkMetafieldsMatch(variantItem, filterValue) {
       
        // Récupère les valeurs des métadonnées personnalisées depuis les attributs data-*
        const forme = variantItem.getAttribute('data-forme');
        const matiere = variantItem.getAttribute('data-matiere');
        const collectionName = variantItem.getAttribute('data-collection');
        //console.log('Compare filters and metafields', filterValue, forme, matiere, collectionName)

        // Vérifie si l'une des métadonnées correspond à la valeur du filtre
        const matchesMetafields = (
            forme === filterValue || 
            matiere === filterValue || 
            collectionName === filterValue
        );

        return matchesMetafields;
      }
    
      static getFiltersFromHTML(parsedHTML) {
        // Sélectionnez tous les éléments de filtre avec la classe 'facets__item'
        return Array.from(parsedHTML.querySelectorAll('.list-menu__item.facets__item, .list-menu__item.mobile-facets__item')).map((filterElement, index) => {
          // Récupérer le nom du paramètre à partir de l'attribut 'name' de l'input checkbox
          //console.log('filterElement', filterElement)
          const checkboxInput = filterElement.querySelector('input[type="checkbox"]');
          const paramName = checkboxInput ? checkboxInput.name : '';
      
          // Récupérer la valeur et l'étiquette affichée
          const label = checkboxInput ? checkboxInput.value : '';
          const countText = filterElement.querySelector('span[aria-hidden="true"]');
          const count = countText ? countText.textContent.match(/\((\d+)\)/)?.[1] : '0';
          const filterSpan = filterElement.querySelector('.filter-value');
          const filterValue = filterSpan ? filterSpan.textContent : '';
      
          return {
            param_name: paramName,
            values: [{
              label: filterValue,
              count: parseInt(count, 10), // Convertir le compte en nombre
              index: index
            }]
          };
        });
      }      
  
    static renderActiveFacets(html) {
      const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];
  
      activeFacetElementSelectors.forEach((selector) => {
        const activeFacetsElement = html.querySelector(selector);
        if (!activeFacetsElement) return;
        document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
      })
  
      FacetFiltersForm.toggleActiveFacets(false);
    }
  
    static renderAdditionalElements(html) {
      const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];
  
      mobileElementSelectors.forEach((selector) => {
        if (!html.querySelector(selector)) return;
        document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
      });
  
      document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
    }
  
    static renderCounts(source, target) {
      const targetElement = target.querySelector('.facets__selected');
      const sourceElement = source.querySelector('.facets__selected');
  
      const targetElementAccessibility = target.querySelector('.facets__summary');
      const sourceElementAccessibility = source.querySelector('.facets__summary');
  
      if (sourceElement && targetElement) {
        target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
      }
  
      if (targetElementAccessibility && sourceElementAccessibility) {
        target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
      }
    }
  
    static updateURLHash(searchParams) {
      history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
    }
  
    static getSections() {
      return [
        {
          section: document.getElementById('product-grid').dataset.id,
        }
      ]
    }
  
    createSearchParams(form) {
      const formData = new FormData(form);
      const searchParams = new URLSearchParams();

      // Ajouter uniquement les paramètres non vides
      for (const [key, value] of formData) {
        if (value) {
          searchParams.append(key, value);
        }
      }

      return searchParams.toString();
    }
  
    onSubmitForm(searchParams, event) {
      FacetFiltersForm.renderPage(searchParams, event);
    }
  
    onSubmitHandler(event) {
      event.preventDefault();
      const sortFilterForms = document.querySelectorAll('facet-filters-form form');
  
      if (event.srcElement.className === 'mobile-facets__checkbox') {
          const searchParams = this.createSearchParams(event.target.closest('form'));
          this.onSubmitForm(searchParams, event);
      } else {
          const forms = [];
          const isMobile = event.target.closest('form')?.id === 'FacetFiltersFormMobile';
  
          sortFilterForms.forEach((form) => {
              if (!isMobile) {
                  if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
                      const noJsElements = document.querySelectorAll('.no-js-list');
                      noJsElements.forEach((el) => el.remove());
                      forms.push(this.createSearchParams(form));
                  }
              } else if (form.id === 'FacetFiltersFormMobile') {
                  forms.push(this.createSearchParams(form));
              }
          });
          this.onSubmitForm(forms.join('&'), event);
      }
    }
  
    onActiveFilterClick(event) {
      event.preventDefault();
      FacetFiltersForm.toggleActiveFacets();
      const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
      FacetFiltersForm.renderPage(url);
    }
  }
  
  FacetFiltersForm.filterData = [];
  FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
  FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
  customElements.define('facet-filters-form', FacetFiltersForm);
  FacetFiltersForm.setListeners();

  // Ajoutez cet écouteur d'événement pour filtrer les variantes au chargement de la page
  document.addEventListener('DOMContentLoaded', () => {
    // Obtenez le HTML initial de la grille de produits uniquement
    const initialHTML = document.querySelector('#ProductGridContainer').innerHTML;
    // Appelez la méthode de filtrage des variantes avec le HTML initial de la grille de produits
    const params = FacetFiltersForm.searchParamsInitial;
    FacetFiltersForm.renderProductGridContainer(initialHTML, params);
  });
  
  class PriceRange extends HTMLElement {
    constructor() {
      super();
      this.querySelectorAll('input')
        .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
      this.setMinAndMaxValues();
    }
  
    onRangeChange(event) {
      this.adjustToValidValues(event.currentTarget);
      this.setMinAndMaxValues();
    }
  
    setMinAndMaxValues() {
      const inputs = this.querySelectorAll('input');
      const minInput = inputs[0];
      const maxInput = inputs[1];
      if (maxInput.value) minInput.setAttribute('max', maxInput.value);
      if (minInput.value) maxInput.setAttribute('min', minInput.value);
      if (minInput.value === '') maxInput.setAttribute('min', 0);
      if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
    }
  
    adjustToValidValues(input) {
      const value = Number(input.value);
      const min = Number(input.getAttribute('min'));
      const max = Number(input.getAttribute('max'));
  
      if (value < min) input.value = min;
      if (value > max) input.value = max;
    }
  }
  
  class FacetRemove extends HTMLElement {
    constructor() {
      super();
      const facetLink = this.querySelector('a');
      facetLink.setAttribute('role', 'button');
      facetLink.addEventListener('click', this.closeFilter.bind(this));
      facetLink.addEventListener('keyup', (event) => {
        event.preventDefault();
        if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
      });
      
      this.deselectPrefilter();
    }
  
    closeFilter(event) {
      event.preventDefault();
      const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
      form.onActiveFilterClick(event);
      this.deselectPrefilter();
    }
  
    deselectPrefilter() {
      const currentURL = new URL(window.location.href);
      const currentParams = new URLSearchParams(currentURL.search);
      const prefilters = document.querySelectorAll('.filter-block.is-current');
      
      prefilters.forEach(prefilter => {
        const prefilterURL = new URL(prefilter.querySelector('a').href);
        const prefilterParams = new URLSearchParams(prefilterURL.search);
        let isCurrent = true;
  
        for (let [key, value] of prefilterParams) {
          if (currentParams.get(key) !== value) {
            isCurrent = false;
            break;
          }
        }
  
        if (!isCurrent) {
          prefilter.classList.remove('is-current');
        }
      });
    }
  }
  
  customElements.define('facet-remove', FacetRemove);

  function updateLinks() {
    document.querySelectorAll('li[data-size="+18 mois"][data-forme="Ronde"]').forEach(li => {
        li.querySelectorAll('a.full-unstyled-link').forEach(link => { 
            if (link.textContent.includes("+18 mois")) {
                link.textContent = link.textContent.replace("+18 mois", "+6 mois");
            }
        });
    });
}

// Exécuter le script au chargement initial
document.addEventListener("DOMContentLoaded", function () {
  updateLinks();
});